import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";

import API from "../../Services/API";
import {toast} from "react-toastify";
import {useParams } from "react-router-dom";
import {HiOutlineLocationMarker, HiOutlineQrcode} from "react-icons/hi";
import {BsCalendar4Week} from "react-icons/bs";
import {TbCoin, TbStatusChange} from "react-icons/tb";
import { MdOutlineWorkOutline} from "react-icons/md";
import {CiPercent, CiViewList} from "react-icons/ci";
import {GiTakeMyMoney, GiTwoCoins} from "react-icons/gi";
import {TfiCup} from "react-icons/tfi";
import {LiaMoneyCheckAltSolid} from "react-icons/lia";
import {HiOutlineCheckBadge} from "react-icons/hi2";


const currencyFormat = Intl.NumberFormat('en-US');

function Order() {
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [order, setOrder] = React.useState([]);
    const [status, setStatus] = React.useState(4);


    let totalPrice = 0;
    let totalDiscount = 0;
    let totalTax = 0;

    React.useEffect(() => {
        const params = {

        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, [id, status]);

    const onButtonClick =  () => {
        setIsLoaded(false);
        const request = {
            order: id,
            status
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true);
                setStatus(0)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });
    }

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='مشاهده سفارش' hasBack={true}  />

            {
                isLoaded &&
                <section className="container-fluid  mt-3 py-5 rtl px-0   ">
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <HiOutlineQrcode />
                        </div>
                        <div className="col-5 text-small-2">
                            کد رهگیری:
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {order.tracking_code}
                        </div>
                    </div>
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <TbStatusChange />
                        </div>
                        <div className="col-5 text-small-2">
                            وضعیت سفارش
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2" style={{color: order.last_status.color}}>
                            {order.last_status.title}
                        </div>
                        {
                            order.last_status.id === 1 ?

                                <div className="col-12 mt-3 text-center">
                                    <button className="btn btn-warning text-small-2 w-100"
                                    onClick={onButtonClick}
                                    >
                                        لغو سفارش
                                    </button>
                                </div> : ''
                        }

                    </div>

                    <div className="row mx-2 mb-3  border-bottom pb-2">
                        <div className="col-1">
                            <BsCalendar4Week />
                        </div>
                        <div className="col-4 text-small-2">
                            تاریخ ثبت
                        </div>
                        <div className="col-7 text-start fw-bold text-small-2">
                            {order.date}
                        </div>
                    </div>
                    <div className="row mx-2 mb-3  pb-2">
                        <div className="col-1">
                            <TfiCup />
                        </div>
                        <div className="col-5 text-small-2">
                             امتیاز دریافتی
                        </div>
                        <div className="col-6 text-start text-primary-color fw-bold text-small-2">
                            {order.totalScore}
                            &nbsp;
                            امتیاز
                        </div>
                    </div>

                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <HiOutlineLocationMarker />
                        </div>
                        <div className="col-11 text-small-2 pt-1">
                            <b>{order.address.title}</b> :&nbsp;
                            {order.address.address}
                        </div>
                    {/*    <div className="col-4 text-start fw-bold text-small-2 pt-1">
                            <a href={`geo:${order.address.lat},${order.address.long}`} rel="noreferrer" target='_blank' >مشاهده روی نقشه</a>
                        </div>*/}
                    </div>
                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <MdOutlineWorkOutline />
                        </div>
                        <div className="col-6 text-small-2 pt-1">
                            <b>{order.vendor.title}</b>
                        </div>
                        <div className="col-5 text-start fw-bold text-small-2 pt-1">
                            <a href={`tel:${order.vendor.support_phone}`} rel="noreferrer" target='_blank' >{order.vendor.support_phone}</a>
                        </div>
                    </div>
                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1 mb-3">
                            <CiViewList />
                        </div>
                        <div className="col-11 text-small-2 fw-bold pt-1 mb-3">
                            فاکتور
                        </div>

                        <div className="col-1 text-small-1 text-center border-bottom py-2">
                            #
                        </div>
                        <div className="col-6 text-small-1 text-center border-bottom py-2">
                            عنوان
                        </div>
                        <div className="col-3 text-small-1 text-center border-bottom py-2">
                            فی
                        </div>
                        <div className="col-2 text-small-1 text-center border-bottom py-2">
                            تعداد
                        </div>

                        {

                            order.details.map((detail,index) => {

                                totalPrice += parseInt(detail.price * detail.count);
                                if(detail.tax_percent) {
                                    let taxAmount = detail.tax_percent * detail.price / 100;
                                    totalTax += parseInt(taxAmount * detail.count);
                                }

                                if(detail.discount_percent) {
                                    let discountAmount = detail.discount_percent * detail.price / 100;
                                    totalDiscount += parseInt(discountAmount * detail.count);
                                }


                                return (
                                    <React.Fragment key={index}>
                                        <div className="col-1 text-small-1 text-center border-bottom py-2">
                                            {index + 1}
                                        </div>
                                        <div className="col-6 text-small-2 text-center border-bottom py-2 fw-bold">
                                            {detail.product.name}
                                        </div>
                                        <div className="col-3 text-small-1 text-center border-bottom py-2">
                                            {currencyFormat.format(detail.price)}
                                        </div>
                                        <div className="col-2 text-small-1 text-center border-bottom py-2">
                                            {detail.count}
                                        </div>
                                    </React.Fragment>
                                )
                            })


                        }
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-3">
                            <TbCoin className='ms-2' />
                            مبلغ فاکتور
                        </div>
                        <div className="col-5 fw-bold mt-3 text-secondary text-small-2  text-start">
                            {currencyFormat.format(totalPrice)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                       <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2' />
                            تخفیف
                        </div>
                        <div className="col-5 fw-bold mt-3 text-success  border-bottom pb-2 text-start">
                            {currencyFormat.format(totalDiscount)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                       <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2' />
                            تخفیف حجمی
                        </div>
                        <div className="col-5 fw-bold mt-3 text-success  border-bottom pb-2 text-start">
                            {currencyFormat.format(order.amount_discount)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2' />
                            تخفیف خرید نقدی
                        </div>
                        <div className="col-5 fw-bold mt-3 text-success  border-bottom pb-2 text-start">
                            {currencyFormat.format(order.pay_amount *  (order.cash_discount_percent / 100))}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                       <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2' />
                            مالیات
                        </div>
                        <div className="col-5 fw-bold mt-3 text-danger  border-bottom pb-2 text-start">
                            {currencyFormat.format(order.tax_amount)}
                            &nbsp;
                            ریال
                        </div>
                        {
                            order.festival_prize > 0 && (
                                <>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                       <div className="col-5 mt-3 text-small-2 border-bottom pb-2 text-primary-color">
                            <HiOutlineCheckBadge className='ms-2  text-big-3' />
                            هدیه جشنواره
                        </div>
                        <div className="col-5 fw-bold mt-3 text-primary-color  border-bottom pb-2 text-start">
                            {currencyFormat.format(order.festival_prize)}
                            &nbsp;
                            ریال
                        </div>
                                </>
                    ) }
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>

                        <div className="col-5 mt-3 text-small-2">
                            <GiTwoCoins className='ms-2' />
                            مبلغ قابل پرداخت:
                        </div>
                        <div className="col-5 fw-bold mt-3  text-start">
                            { currencyFormat.format(order.pay_amount * ( 1 - (order.cash_discount_percent / 100)))}
                            &nbsp;
                            ریال
                        </div>
                    </div>
                    {
                        order.cash_discount_percent > 0 ?
                    <div
                        className="row mt-4 mx-3 p-3 bg-success-subtle rounded border border-success"
                    >
                        <div className="col-2">
                            <GiTakeMyMoney className='text-big-5 text-success' />
                        </div>
                        <div className="col-10">
                            <span className='fw-bold'>خرید به صورت نقدی</span>
                        </div>
                    </div> :
                            <div className="row my-2 mb-5 mx-2 p-3 bg-warning-subtle rounded border border-warning"

                            >
                                <div className="col-2">
                                    <LiaMoneyCheckAltSolid  className='text-big-5 text-danger' />
                                </div>
                                <div className="col-10">
                                    <span className='fw-bold'>خرید به صورت چکی</span>
                                <div className='text-start'>
                                    { order.order_description}
                                </div>
                                </div>
                            </div>
                    }
                </section>
            }


        </React.Fragment>
    );
}

export default Order;